window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener("shopify:section:load", this._onSectionLoad.bind(this));
  document.addEventListener("shopify:section:unload", this._onSectionUnload.bind(this));
  document.addEventListener("shopify:section:select", this._onSelect.bind(this));
  document.addEventListener("shopify:section:deselect", this._onDeselect.bind(this));
  document.addEventListener("shopify:block:select", this._onBlockSelect.bind(this));
  document.addEventListener("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var id = container.getAttribute("data-section-id");
    var type = container.getAttribute("data-section-type");
    constructor = constructor || this.constructors[type];
    if (typeof constructor === "undefined") return;
    var instance = Object.assign(new constructor(container), {id:id,type:type,container:container});
    this.instances.push(instance);
  },
  _onSectionLoad: function (evt) { var container=document.querySelector('[data-section-id="'+evt.detail.sectionId+'"]'); if(container)this._createInstance(container); },
  _onSectionUnload: function (evt) { this.instances=this.instances.filter(function(instance){var isEventInstance=instance.id===evt.detail.sectionId;if(isEventInstance&&typeof instance.onUnload==='function')instance.onUnload(evt);return !isEventInstance;}); },
  _onSelect: function (evt) { var instance=this.instances.find(function(instance){return instance.id===evt.detail.sectionId;}); if(typeof instance!=="undefined"&&typeof instance.onSelect==='function')instance.onSelect(evt); },
  _onDeselect: function (evt) { var instance=this.instances.find(function(instance){return instance.id===evt.detail.sectionId;}); if(typeof instance!=="undefined"&&typeof instance.onDeselect==='function')instance.onDeselect(evt); },
  _onBlockSelect: function (evt) { var instance=this.instances.find(function(instance){return instance.id===evt.detail.sectionId;}); if(typeof instance!=="undefined"&&typeof instance.onBlockSelect==='function')instance.onBlockSelect(evt); },
  _onBlockDeselect: function (evt) { var instance=this.instances.find(function(instance){return instance.id===evt.detail.sectionId;}); if(typeof instance!=="undefined"&&typeof instance.onBlockDeselect==='function')instance.onBlockDeselect(evt); },
  register: function (type, constructor) { this.constructors[type]=constructor; document.querySelectorAll('[data-section-type="'+type+'"]').forEach(function(container){this._createInstance(container,constructor);}.bind(this)); }
});

theme.collectionSlider = (function () {
  function sliderProduct(e) {
    let sliderContainer="",extraLargeDesktopShow=4,largeDesktopShow=3,tabletShow=3,mobileShow=2,sliderGrid="column",sliderAutoplay=e.dataset.autoplay,autoPlayValue=false,autoPlayTime=parseInt(e.dataset.autoplayTime),rowGap=Number(e.dataset.rowSpace)||30;
    if(sliderAutoplay==="true")autoPlayValue={delay:autoPlayTime};
    if(e.dataset.sliderEnable==="true"){sliderContainer=e.querySelector(".productSlider");extraLargeDesktopShow=parseInt(e.dataset.showExtraLarge);mobileShow=parseInt(e.dataset.showMobile);}else{sliderContainer=false;}
    var featuredCollection=new Swiper(sliderContainer,{loop:true,slidesPerView:mobileShow,spaceBetween:20,autoplay:autoPlayValue,pagination:{el:e.querySelector(".swiper-pagination"),clickable:true,type:"fraction"},navigation:{nextEl:e.querySelector(".swiper-button-next"),prevEl:e.querySelector(".swiper-button-prev")},breakpoints:{640:{slidesPerView:mobileShow,spaceBetween:20},750:{slidesPerView:largeDesktopShow,spaceBetween:20},992:{slidesPerView:extraLargeDesktopShow,spaceBetween:20},1200:{slidesPerView:extraLargeDesktopShow,spaceBetween:rowGap}}});
    if(!sliderContainer==false&&sliderAutoplay==="true"){sliderContainer.addEventListener("mouseenter",function(){featuredCollection.autoplay.stop();});sliderContainer.addEventListener("mouseleave",function(){featuredCollection.autoplay.start();});}
  }
  return sliderProduct;
})();

/* XVORA Banner List — premium mobile carousel */
theme.bannerListCarousel=(function(){
  function init(root){
    if(!root||root.dataset.xvoraBannerCarousel==="1")return;
    var track=root.querySelector('.banner-grid');
    if(!track)return;
    var originalItems=[].slice.call(track.querySelectorAll('.banner_list_item'));
    var numOriginals=originalItems.length;
    if(numOriginals<2)return;
    root.dataset.xvoraBannerCarousel='1';
    
    // Clean up any existing carousel controls that might be rendered
    var existingControls = root.querySelector('.banner-list-carousel-controls');
    if (existingControls) existingControls.remove();
    
    // Clone all items once to allow seamless looping
    originalItems.forEach(function(item){
      var clone=item.cloneNode(true);
      clone.classList.add('is-clone');
      track.appendChild(clone);
    });
    
    var items=[].slice.call(track.querySelectorAll('.banner_list_item'));
    track.classList.add('carousel-active');
    
    var index=0;
    var timer=null;
    var delay=4000;
    var transitionDuration=600;
    var isTransitioning=false;
    
    function isMobile(){
      return window.innerWidth < 750;
    }
    
    function getXOffset(idx){
      if(idx>=items.length)idx=0;
      var item=items[idx];
      var gap=parseFloat(window.getComputedStyle(track).gap||'0')||0;
      // Offset by gap to give a beautiful margin on left
      return -item.offsetLeft + gap;
    }
    
    function updateSlide(animate){
      if(!isMobile()){
        track.style.transition='none';
        track.style.transform='none';
        return;
      }
      if(animate){
        track.style.transition='transform '+transitionDuration+'ms cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      }else{
        track.style.transition='none';
      }
      var x=getXOffset(index);
      track.style.transform='translate3d('+x+'px,0,0)';
    }
    
    function slideNext(){
      if(isTransitioning)return;
      isTransitioning=true;
      index++;
      updateSlide(true);
    }
    
    function slidePrev(){
      if(isTransitioning)return;
      isTransitioning=true;
      index--;
      if(index<0){
        index=numOriginals-1;
        updateSlide(false);
        track.offsetHeight; // Force reflow
        index++;
      }
      updateSlide(true);
    }
    
    track.addEventListener('transitionend',function(e){
      if(e.target!==track)return;
      isTransitioning=false;
      if(index>=numOriginals){
        index=0;
        updateSlide(false);
      }
    });
    
    // Swipe handling
    var touchStartX=0;
    var touchMoveX=0;
    var currentTranslateX=0;
    var isSwiping=false;
    
    track.addEventListener('touchstart',function(e){
      if(!isMobile())return;
      stop();
      if(isTransitioning)return;
      touchStartX=e.touches[0].clientX;
      var style=window.getComputedStyle(track);
      var matrix=new WebKitCSSMatrix(style.transform);
      currentTranslateX=matrix.m41;
      track.style.transition='none';
      isSwiping=true;
    },{passive:true});
    
    track.addEventListener('touchmove',function(e){
      if(!isSwiping||isTransitioning)return;
      touchMoveX=e.touches[0].clientX;
      var diffX=touchMoveX-touchStartX;
      track.style.transform='translate3d('+(currentTranslateX+diffX)+'px,0,0)';
    },{passive:true});
    
    track.addEventListener('touchend',function(e){
      if(!isSwiping||isTransitioning)return;
      isSwiping=false;
      var diffX=touchMoveX-touchStartX;
      if(Math.abs(diffX)>50){
        if(diffX<0){
          slideNext();
        }else{
          slidePrev();
        }
      }else{
        updateSlide(true);
      }
      start();
    });
    
    function start(){
      if(timer)return;
      timer=setInterval(slideNext,delay);
    }
    
    function stop(){
      if(timer){
        clearInterval(timer);
        timer=null;
      }
    }
    
    root.addEventListener('mouseenter',stop);
    root.addEventListener('mouseleave',start);
    
    window.addEventListener('resize',function(){
      updateSlide(false);
    },{passive:true});
    
    updateSlide(false);
    start();
  }
  function boot(){document.querySelectorAll('.banner-list-wrapper').forEach(init);}
  document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',function(){setTimeout(boot,50);});
  return {init:init};
})();

document.addEventListener("DOMContentLoaded", function () {
  let sections=new theme.Sections(),headerSearchModule=new theme.Sections(),headerCartModule=new theme.Sections(),headerStickyModule=new theme.Sections(),headerMainMenu=new theme.Sections();
  headerMainMenuSlider=new theme.Sections();
  sections.register("scrolling_bar",theme.scrollingText);sections.register("header",theme.headerSection);headerMainMenuSlider.register("header",theme.menuProductSlider);headerSearchModule.register("header",theme.headerSearch);headerCartModule.register("header",theme.CartDrawerActions);headerStickyModule.register("header",theme.headerSticky);headerMainMenu.register("header",theme.headerMainMenuModule);sections.register("footer",theme.footerSection);sections.register("slideShow",theme.SlideShow);sections.register("collection-product",theme.collectionProduct);sections.register("product-slider",theme.collectionSlider);sections.register("accordion",theme.accordion);sections.register("blog",theme.blog);
});
